// src/hooks/useQueuedPhotos.js
//
// Photos a crew shot without signal, shaped like API photo rows so a gallery can
// render them next to the synced ones. Without this the shot vanishes from the UI
// until it syncs, which reads as "it didn't save" and gets it taken again.
//
// Object URLs are created here and revoked when the list changes or the component
// unmounts — a truck tablet left open all day would otherwise leak every photo
// blob it has queued.

import { useEffect, useState } from 'react';
import { subscribe, getQueuedPhotos } from '../services/outbox';

export function useQueuedPhotos(jobId) {
  const [queued, setQueued] = useState([]);

  useEffect(() => {
    let alive = true;
    let current = [];

    const revoke = (list) => {
      list.forEach((p) => {
        if (p.url) {
          try {
            URL.revokeObjectURL(p.url);
          } catch (e) {
            /* already revoked */
          }
        }
      });
    };

    const refresh = async () => {
      const next = await getQueuedPhotos(jobId);
      if (!alive) {
        revoke(next);
        return;
      }
      revoke(current);
      current = next;
      setQueued(next);
    };

    refresh();
    const unsub = subscribe(refresh);

    return () => {
      alive = false;
      unsub();
      revoke(current);
    };
  }, [jobId]);

  return queued;
}

export default useQueuedPhotos;
